export default "__VITE_PUBLIC_ASSET__4b480b36__"